//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "KeyContactModal",
  components: {
    GenericModal
  },
  props: {
    contactName: {
      type: String,
      required: true
    },
    contactEmail: {
      type: String,
      required: true
    }
  }
});